export const MARKET_SEGMENTS = [
	{ id: 'B2B', name: 'b2b' },
	{ id: 'B2C', name: 'b2c' },
	{ id: 'B2B2C', name: 'b2b2c' },
]
